/* External Imports */
import { Box, Text } from '@chakra-ui/react';
/* Internal Imports */
/* Components */
import LazyLoadImageComponent from '@app-ps/Components/Ui/LazyLoadImageComponent';
import config from '@config';
/**
 *
 * @param {Object} sectionContent
 * @param {Object} region - Data from api
 * @param {Object} lang - Data from api
 * @returns
 */
const ThreeCardSection = ({ sectionContent }) => {
  const simpleCardGroup = sectionContent.find(
    item => item._modelApiKey === 'simple_card_group'
  );

  return (
    <Box
      width="100%"
      px="16px"
      pt={{ base: '2rem', lg: '6rem' }}
      pb={{ base: '2rem', lg: '6rem' }}
      mt={{ base: '-30rem', sm: '-12rem' }}
    >
      <Box
        display="flex"
        // alignItems="center"
        alignItems={{
          base: 'center',
          md: 'center',
          lg: 'baseline',
          xl: 'center',
        }}
        justifyContent="center"
        // flexDirection={{ base: 'column', lg: 'row' }}
        flexWrap={{ base: 'wrap', lg: 'nowrap', xl: 'wrap' }}
        flexDir={{ base: 'column', lg: 'row' }}
        gap={{ base: '1rem', md: '30px', '2xl': '2rem' }}
        maxW={{ base: '100%', md: '1200px', xl: '1480px' }}
        mx="auto"
        w="100%"
      >
        {simpleCardGroup.simpleCards.map((card, index) => (
          <Box
            key={index}
            width={{ base: '100%', sm: '370px', '2xl': '470px' }}
            mb="15px"
          >
            <Box>
              <LazyLoadImageComponent
                src={card.rectangularImage.url}
                alt={card.rectangularImage.alt || 'Card Image'}
                width="100%"
                // height={200}
                // objectFit="cover"
                height="100%"
              />
            </Box>
            <Box
              marginTop={{ base: '16px', md: '32px' }}
              padding={{ base: '0', sm: '0px 16px 0px 16px' }}
            >
              <Text
                textColor="white"
                textAlign="center"
                fontFamily="var(--FedraSansStd-medium)"
                fontSize={{ base: '20px', md: '1.25rem' }}
                fontWeight="500"
                letterSpacing="1%"
                lineHeight={{ base: '24px', md: '28.8px' }}
                minHeight={{ lg: '52px' }}
              >
                {card.title}
              </Text>
              <Text
                textColor="rgba(254, 250, 246, 0.7)"
                marginTop={{
                  base: '8px',
                  md: '16px',
                  lg: '0',
                  xl: '0',
                  '2xl': '-.5rem',
                }}
                paddingX={{ base: '.4rem', md: '0' }}
                textAlign="center"
                fontFamily="var(--FedraSansStd-book)"
                fontSize={{ base: '0.875rem', md: '1.125rem' }}
                fontWeight="400"
                letterSpacing="2%"
                lineHeight={{ base: '22.4px', md: '28.8px' }}
                minHeight={{ lg: '203px' }}
              >
                {card.descriptionText}
              </Text>
            </Box>
          </Box>
        ))}
      </Box>
      <Box
        display={{ base: 'flex' }}
        width={{ base: '200px', lg: '350px' }}
        justifyContent={'center'}
        mt={{ base: '2rem' }}
        mx="auto"
        maxW="500px"
      >
        <LazyLoadImageComponent
          src={`${config.imgPath}/d/46272/1721626573-threekolam.png`}
          alt="Workshop Kolam"
          // width={400}
          // height={250}
        />
      </Box>
    </Box>
  );
};

export default ThreeCardSection;
